import {Injectable, InjectionToken} from "@angular/core";

@Injectable()
export class DxInMemoryBackendConfig {
  public env: any;
  public apiMocks?: Map<string, any[]>;

  constructor(config: Partial<DxInMemoryBackendConfig>) {
    this.env = config.env;
    this.apiMocks = config.apiMocks;
  }
}

/**
 *    Эти константы объявлены здесь потому что объявление их в dx-in-memory-backend.module
 *    c последующим использованием в сервисах этого же модуля приводит к возникновению
 *    циклических зависимостей типа: module -> service -> module.
 *
 *    ПС: Создавать отдельный файл под каждую константу как-то не айс.
 **/

/** Токен для распространения конфигов через механизм DI **/
export const DX_IN_MEMORY_BACKEND_CONFIG = new InjectionToken<DxInMemoryBackendConfig>('DX_IN_MEMORY_BACKEND_CONFIG');


export const DX_API_MOCKS: InjectionToken<Map<string, any[]>> = new InjectionToken<Map<string, any[]>>('DX_API_MOCKS');
